module.exports = __webpack_public_path__ + "static/media/13yokosuka.1edc6047.png";